import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { RichTextAreaControlConfig } from 'src/app/features/reactive-forms-ui/models/rich-text-area-control-config';

@Component({
  selector: 'close-ticket-dialog',
  templateUrl: './close-ticket-dialog.component.html',
  styleUrls: ['./close-ticket-dialog.component.scss'],
  standalone: false,
})
export class CloseTicketDialogComponent implements OnInit {
  resolutionStatuses = [
    { value: 'noSupport', name: 'No longer need support' },
    { value: 'duplicateTicket', name: 'Duplicate ticket' },
    { value: 'other', name: 'Other' },
  ];

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    resolutionStatus: new UntypedFormControl('', Validators.required),
    resolutionText: new UntypedFormControl(''),
  });

  resolutionTextControlConfig = new RichTextAreaControlConfig({
    placeholder: 'Please provide some details',
    label: null,
  });

  showResolutionText = false;

  confirmTooltip = 'Please select an option';

  constructor(
    protected _sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      confirmAction: (resolutionText: string) => void;
      isLoadingConfirm?: boolean;
    },
  ) {}

  ngOnInit(): void {
    this.formGroup.get('resolutionStatus').valueChanges.subscribe((value) => {
      this.showResolutionText = value === 'other' || value === 'noSupport';
    });
  }

  onConfirm() {
    const selectedStatus = this.resolutionStatuses.find(
      (status) => status.value === this.formGroup.get('resolutionStatus').value,
    ).name;
    const resolutionText = this.formGroup.get('resolutionText').value as string;

    this.data.confirmAction(`${selectedStatus}${resolutionText?.length >= 1 ? `: ${resolutionText}` : ''}`);
  }
}
